import { Checkbox, IconButton } from "@mui/material";
import { AddButton } from "app/components/Button/AddButton";
import { FilterSelect } from "app/components/FilterSelect";
import { CheckboxIcon, CheckboxOutlineIcon, ThreedotIcon } from "app/icons";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import {
  selectCustomersStatusFilter,
  selectCustomerStatusLabelKey,
} from "../../redux/selector";
import { customersActions } from "../../redux/slice";
import { CustomerStatus, CustomerStatusFilter } from "../../types";
import { useStyles } from "./styles";

const STATUS_OPTIONS: CustomerStatusFilter[] = [
  "ALL",
  CustomerStatus.ACTIVE,
  CustomerStatus.INACTIVE,
];

const CHECKBOX_SIZE = 18;
const checkboxControl = {
  disableRipple: true,
  icon: <CheckboxOutlineIcon width={CHECKBOX_SIZE} height={CHECKBOX_SIZE} />,
  checkedIcon: <CheckboxIcon width={CHECKBOX_SIZE} height={CHECKBOX_SIZE} />,
  sx: { p: 0, width: CHECKBOX_SIZE, height: CHECKBOX_SIZE },
};

const ActionBar = () => {
  const { t } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();
  const statusFilter = useSelector(selectCustomersStatusFilter);

  const getStatusLabel = (value: CustomerStatusFilter) => {
    if (value === "ALL") {
      return t("CUSTOMERS.STATUS_FILTER.ALL");
    }

    return t(selectCustomerStatusLabelKey(value));
  };

  const renderOptionContent = (option: CustomerStatusFilter) => {
    let badge: React.ReactNode;
    if (option === CustomerStatus.ACTIVE) {
      badge = <span className={styles.activeBadge}>{getStatusLabel(option)}</span>;
    } else if (option === CustomerStatus.INACTIVE) {
      badge = <span className={styles.inactiveBadge}>{getStatusLabel(option)}</span>;
    } else {
      badge = <span className={styles.optionLabel}>{getStatusLabel(option)}</span>;
    }
    return (
      <div className={styles.optionRow}>
        <Checkbox {...checkboxControl} checked={option === statusFilter} className={styles.checkbox} />
        {badge}
      </div>
    );
  };

  return (
    <div className={styles.root} dir="ltr">
      <div className={styles.actions}>
        <AddButton
          label={t("CUSTOMERS.ACTIONS.ADD_CUSTOMER")}
          onClick={() => dispatch(customersActions.openAddModal())}
        />
        <IconButton size="small" className={styles.iconButton}>
          <ThreedotIcon />
        </IconButton>
      </div>

      <FilterSelect
        label={t("CUSTOMERS.STATUS_FILTER.LABEL")}
        value={statusFilter}
        options={STATUS_OPTIONS}
        getOptionLabel={getStatusLabel}
        renderOption={renderOptionContent}
        onChange={(value) => {
          dispatch(customersActions.setCustomersStatusFilter(value));
          dispatch(customersActions.getCustomersList());
        }}
      />
    </div>
  );
};

export default ActionBar;
